import { jsx as _jsx } from "react/jsx-runtime";
import Modal from '../Modal';
import EquipamentoForm from './EquipamentoForm';
const EquipamentoModal = ({ isOpen, onClose, equipamento, clienteId, onSuccess }) => {
    const handleSuccess = () => {
        if (onSuccess) {
            onSuccess();
        }
        onClose();
    };
    const handleCancel = () => {
        onClose();
    };
    return (_jsx(Modal, { isOpen: isOpen, onClose: onClose, title: equipamento ? 'Editar Equipamento' : 'Novo Equipamento', size: "xl", children: _jsx(EquipamentoForm, { equipamento: equipamento, clienteId: clienteId, onSuccess: handleSuccess, onCancel: handleCancel }) }));
};
export default EquipamentoModal;
